"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (brand) => {
    switch (brand) {
        case "4njbets":
            return "nj";
        case "pabets":
            return "pa";
        case "iowa":
            return "ia";
        default:
            return "all";
    }
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/location.js